import { render, staticRenderFns } from "./EditInventoryManagement.vue?vue&type=template&id=4675ef74&scoped=true&"
import script from "./EditInventoryManagement.vue?vue&type=script&lang=js&"
export * from "./EditInventoryManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4675ef74",
  null
  
)

export default component.exports